import * as yup from "yup";
import _ from "lodash";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useAgentsAdminContext } from "../../../providers/agents-admin.provider";
import { useCreateSponsor } from "../../../../../../services/microservice/admin/sponsors/use-sponsors-admin";

interface IFormValue {
  name: string;
  idSystem: string;
  isActive: IActive;
  dobleAuth: IDobleAuth;
}

interface IActive {
  name: string;
  value: boolean;
}
interface IDobleAuth {
  name: string;
  value: boolean;
}

const formatData = (params: IFormValue) => {
  const { name, idSystem, isActive, dobleAuth } = params;
  const data = {};
  _.set(data, "name", name);
  _.set(data, "idSystem", idSystem);
  _.set(data, "isActive", isActive.value);
  _.set(data, "dobleAuth", dobleAuth.value);
  return data as any;
};

const useSponsorCreateFormUtil = () => {
  const { sponsor } = useAgentsAdminContext();
  const { isLoading, mutateAsync: createSponsor } = useCreateSponsor();
  const initialValues: IFormValue = {
    name: "",
    idSystem: "",
    isActive: null,
    dobleAuth: null,
  };

  const validationSchema = yup.object().shape({
    name: yup.string().required(" Requerido"),
    idSystem: yup.string().required(" Requerido"),
    isActive: yup
      .object()
      .shape({
        name: yup.string().required(" Requerido"),
        value: yup.boolean().required(" Requerido"),
      })
      .required(" Requerido"),
    dobleAuth: yup
      .object()
      .shape({
        name: yup.string().required(" Requerido"),
        value: yup.boolean().required(" Requerido"),
      })
      .required(" Requerido"),
  });

  const navigate = useNavigate();

  const onSubmit = async (values: IFormValue) => {
    try {
      const data = formatData(values);
      await createSponsor(data);
      toast.success("Sponsor creado correctamente");
      navigate(`/${sponsor}/admin/sponsors`);
    } catch (error) {
      toast.error("Error al crear el sponsor");
    }
  };

  return { initialValues, validationSchema, onSubmit, isLoading };
};

export default useSponsorCreateFormUtil;
